export const decisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/distribution";

export const decisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionCacheKeys =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/distribution";
